import { Button, Space } from "antd-mobile";
import React, { useState } from "react";
import { DownOutline } from 'antd-mobile-icons'
const Keyboard = (props) => {


    const {
        onKeyPress = () => { },
        keyboard = "",
        setKeyboard = () => { },
        save,
        input = "",
        setInput = () => { },
        doneTrigger = false,
        setDoneTrigger = () => { }
    } = props;

    const [isNumbersView, setIsNumbersView] = useState(true);

    const letterKeys = [
        ["Q", "W", "E", "R", "T", "Y", "U", "I", "O", "P"],
        ["A", "S", "D", "F", "G", "H", "J", "K", "L"],
        ["Z", "X", "C", "V", "B", "N", "M", "del"],
        [".", "*", "SPACE", "/", "-"],
    ];

    const numberKeys = [
        ["1", "2", "3"],
        ["4", "5", "6"],
        ["7", "8", "9"],
        ["+/-", "0", "Del"],
    ];

    const handleKeyPress = (key) => {
        let newValue = input;

        if (key === "del" || key === "Del") {
            // Remove the last character
            newValue = newValue.slice(0, -1);
        } else if (key === "SPACE") {
            // Add a space
            newValue += " ";
        } else if (key === "+/-") {
            // Toggle positive/negative sign
            if (newValue.startsWith("-")) {
                newValue = newValue.slice(1);
            } else if (newValue) {
                newValue = `-${newValue}`;
            }
        } else {
            // Default: append the key to the input value
            newValue += key;
        }

        setInput(newValue);

        if (onKeyPress) {
            onKeyPress(key);
        }
    };


    const handleDelete = () => {
        const newValue = input.slice(0, -1);
        setInput(newValue);
    };

    const handleSpace = () => {
        const newValue = input + " ";
        setInput(newValue);
    };

    const handleToggleView = () => {
        setIsNumbersView(!isNumbersView);
    };


    const getStyle = (key) => {
        const baseStyle = {

            lineHeight: "20px",
            height: "49px",
            fontSize: "16px",
            border: "1px solid #2b2b2b",
            textAlign: "center", // Centers text inside the boxes
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderLeft: "none",
            borderBottom: "none",
            margin: "0px", // Adds spacing between keys
        };

        // Custom styles for specific keys


        switch (key) {
            case "3":
            case "6":
            case "9":
            case "P":
            case "L":
                return { ...baseStyle, borderRight: "none" };
                break;
            case "del":
                return { ...baseStyle, borderRight: "none", backgroundColor: "#000", };
                break;
            case "SPACE":
                return { ...baseStyle, borderBottom: "1px solid #2b2b2b", borderRight: "none", "backgroundColor" : "#333" };
            case "+/-":
                return { ...baseStyle, backgroundColor: "#000", color: "#fff", borderBottom: "1px solid #2b2b2b" };
            case "Del":
                return { ...baseStyle, backgroundColor: "#000", color: "#fff", borderBottom: "1px solid #2b2b2b", "borderRight": "none" };
            case "0":
                return { ...baseStyle, borderBottom: "1px solid #2b2b2b" };
                case "-":
                    case ".":
                        case "/":
                            case "*":
                            return { ...baseStyle, maxWidth: "50px", backgroundColor: "#000", borderBottom: "1px solid #2b2b2b"};

        }

        return baseStyle;
    };


    return (
        <div className="bm_keyboard">
            <div>


                {(keyboard && <div style={{"marginTop" : "0px"}}><Button onClick={() => setKeyboard("")} color="default" style={{ "borderRadius": "0px", "width": "100%", "backgroundColor": "#000", "border": "none" }}><DownOutline /></Button></div>)}
                {(isNumbersView ? numberKeys : letterKeys).map((row, rowIndex) => (
                    <div key={rowIndex} style={{ display: "flex", gap: "0px", justifyContent: "center" }}>
                        {row.map((key, index) => (
                            <div
                                key={key}
                                style={getStyle(key)}
                                className="adm-number-keyboard-key adm-number-keyboard-key-number"
                                onMouseDown={() => handleKeyPress(key)}
                            >
                                <div style={{ "pointerEvents": "none" }}>{key}</div>
                            </div>
                        ))}
                    </div>
                ))}

                <div className="float-flex" style={{ "padding": "0px" }}>
                    <Button onClick={handleToggleView} color="default" style={{ "borderRadius": "0px", "width": "100%", "backgroundColor": "#000", "border": "none", "height" : "65px" }}><small>{(isNumbersView) ? "ABC" : "123"}</small></Button>
                    <Button onClick={() => {
                        if(keyboard !== "isbn"){
                            setKeyboard("");
                        } else {
                            setDoneTrigger(!doneTrigger)
                        }
                    }} color="primary" style={{ "borderRadius": "0px", "width": "100%" }}><small>GO</small></Button>
                </div>

            </div>
        </div>
    );
};


export default Keyboard;
